<script lang="ts" setup>
import { useRoute } from 'vue-router'

const emit = defineEmits(['close'])
const route = useRoute()
</script>

<template>
  <div v-if="route.name == 'dashboard'" class="flex flex-row items-center gap-6">
    <div class="w-1/2 p-4 bg-white"></div>

    <div class="flex-1 flex flex-col justify-center">
      <Button
        :label="$t('common:close')"
        class="mt-8"
        icon="pi pi-angle-right"
        icon-pos="right"
        size="large"
        @click="emit('close')"
      />
    </div>
  </div>
</template>
